<template>
    <field-stop-location
        class="field-StopLocationVia"
        :type="type"
        :texts="texts"
        :enable-geo="enableGeo"
    />
</template>

<script>
import FieldStopLocation from "@/components/fields/FieldStopLocation";
import { LOCATION_VIA } from "@/store/modules/location";

export default {
    components: {
        FieldStopLocation
    },
    props: {
        enableGeo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_stop_location_via");
        },
        type() {
            return LOCATION_VIA;
        }
    }
};
</script>
